// extracted by mini-css-extract-plugin
export default {"no_data_container":"NoData_no_data_container__-ldLO","image":"NoData_image__jhgpg"};